import {
    Badge,
    Box,
    Button,
    Divider,
    IconButton,
    List,
    ListItemButton,
    ListItemText,
    Menu,
    Tooltip,
    Typography,
} from "@mui/material";
import { useState } from "react";
import { FaBell } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import { useNotifications } from "../../providers/NotificationsProvider";

const ink = "#0B0A08";
const gold = "#C8A459";

export default function NotificationsBell() {
    const navigate = useNavigate();
    const { items, unreadCount, markAsRead, markAllAsRead, refreshNotifications } = useNotifications();
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleOpen = (event) => {
        setAnchorEl(event.currentTarget);
        refreshNotifications();
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleClickItem = async (item) => {
        if (!item.is_read) {
            await markAsRead(item.id);
        }
        handleClose();
        if (item.link) {
            navigate(item.link);
        }
    };

    const handleMarkAll = async () => {
        await markAllAsRead();
    };

    return (
        <>
            <Tooltip title="Notificações">
                <IconButton
                    onClick={handleOpen}
                    aria-label="Notificações"
                    aria-controls={open ? "notifications-menu" : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? "true" : undefined}
                    sx={{
                        color: ink,
                        borderRadius: 1,
                        px: 1,
                        "&:hover": {
                            bgcolor: "rgba(200,164,89,0.12)",
                            color: gold,
                        },
                    }}
                >
                    <Badge
                        badgeContent={unreadCount}
                        sx={{
                            "& .MuiBadge-badge": {
                                bgcolor: gold,
                                color: ink,
                                fontWeight: 700,
                                fontSize: 10,
                            },
                        }}
                    >
                        <FaBell size={18} />
                    </Badge>
                </IconButton>
            </Tooltip>

            <Menu
                id="notifications-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                transformOrigin={{ vertical: "top", horizontal: "right" }}
                PaperProps={{
                    sx: {
                        width: 360,
                        maxWidth: "92vw",
                        mt: 1,
                        border: "1px solid #E5E2DA",
                        boxShadow: "0 8px 24px rgba(11,10,8,0.12)",
                    },
                }}
            >
                <Box sx={{ px: 2, py: 1.25, display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1 }}>
                    <Typography sx={{ fontWeight: 700, fontSize: 14, color: ink }}>
                        Notificações
                    </Typography>
                    {unreadCount > 0 && (
                        <Button size="small" onClick={handleMarkAll} sx={{ textTransform: "none", color: gold, fontWeight: 600 }}>
                            Marcar todas
                        </Button>
                    )}
                </Box>
                <Divider />
                {items.length === 0 ? (
                    <Box sx={{ px: 2, py: 3 }}>
                        <Typography sx={{ fontSize: 13, color: "#6B675E", textAlign: "center" }}>
                            Nenhuma notificação por enquanto.
                        </Typography>
                    </Box>
                ) : (
                    <List dense disablePadding sx={{ maxHeight: 380, overflowY: "auto" }}>
                        {items.map((item) => (
                            <ListItemButton
                                key={item.id}
                                onClick={() => handleClickItem(item)}
                                sx={{
                                    alignItems: "flex-start",
                                    bgcolor: item.is_read ? "transparent" : "rgba(200,164,89,0.08)",
                                    borderBottom: "1px solid #F0EEE8",
                                    py: 1.25,
                                }}
                            >
                                <ListItemText
                                    primary={
                                        <Typography sx={{ fontSize: 13, fontWeight: item.is_read ? 500 : 700, color: ink }}>
                                            {item.title}
                                        </Typography>
                                    }
                                    secondary={
                                        <>
                                            {item.body && (
                                                <Typography component="span" sx={{ display: "block", fontSize: 12, color: "#6B675E", mt: 0.25 }}>
                                                    {item.body}
                                                </Typography>
                                            )}
                                            <Typography component="span" sx={{ display: "block", fontSize: 11, color: "#9A958A", mt: 0.5 }}>
                                                {item.created_at_fmt || item.created_at}
                                            </Typography>
                                        </>
                                    }
                                />
                            </ListItemButton>
                        ))}
                    </List>
                )}
            </Menu>
        </>
    );
}
